var AuthPhoneService = (function () {

    function startAuthorize() {
        var prefix = $('.js-login-phone-prefix');
        var phone = $('.js-input-login-phone');
        var error = $('.js-input-error-phone');

        hideError();
        var isValidate = true;

        if (phone.val().length < 10) {
            isValidate = false;
            showError("Введите корректный номер", ".js-input-error-phone", '#phoneInputWrapper','.js-mod-login-subtitle');
        }

        var strPhone = converStringToPhoneAndAddPrefix(phone.val());

        
        if (strPhone != undefined) {
            if (strPhone.length < 10 || strPhone.charAt(0) != "9") {
                isValidate = false;
                showError("Введите корректный номер", ".js-input-error-phone", '#phoneInputWrapper','.js-mod-login-subtitle');
            }
        } else {
            isValidate = false;
            showError("Введите корректный номер", ".js-input-error-phone", '#phoneInputWrapper','.js-mod-login-subtitle');
        }

        if (isValidate) {
            AppService.toggleLoader();

            var data = {
                phone: "+7 " + removeBreckets(phone.val()),
            };

            $.ajax({
                url: $(this).prop('action'),
                type: $(this).prop('method'),
                data: JSON.stringify(data),
                contentType: 'application/json',
                success: function (response) {
                    AppService.toggleLoader();
                    $('.modal.in').modal('hide');
                    $('#modalCompleteAuthorize').modal('show');
                    $('.js-phone-authorization').text(decoratePhone(response.result.phone));
                    $('.js-input-user-phone').val(decoratePhone(response.result.phone));

                    var time = new Date().getTime() + 1 * 60 * 1000;
                    backTimer(time);
                },
                error: function (data) {
                    AppService.toggleLoader();
                    showError(data.responseJSON.errors.phone[0], ".js-input-error-phone", '#phoneInputWrapper','.js-mod-login-subtitle');
                }
            });
        }

        return false;
    }

    function decoratePhone(phone){
        var result = converStringToPhoneAndAddPrefix(phone);
        result = "+" + result[0]+ " (" + result[1]+result[2]+result[3]+") " + result[4]+result[5]+result[6] + "-" + result[7]+result[8] + "-" +result[9]+result[10];
        return result;
    }

    function converStringToPhoneAndAddPrefix(text){
        var phone = text ?  text : '';

        phone = phone
            .split('+').join('')
            .split('-').join('')
            .split('_').join('')
            .split(' ').join('')
            .split('(').join('')
            .split(')').join('');

        return phone;
    }

    function hideError(){
        $('.has-error').removeClass('has-error');

        $('.js-mod-login-subtitle').show();
        $('.js-input-error').hide();
        $('.js-mod-code-error').hide();
    }

    function removeBreckets(text){
        var phone = text
        .split('(').join('')
        .split(')').join('');

        return phone;
    }

    function showError(errorMessage, errorSelector, fieldSelector, hideSelector){
        $(fieldSelector).addClass('has-error');
        $(errorSelector).text(errorMessage).show();
        if(hideSelector)
            $(hideSelector).hide();
    }

    function completeAuthorize() {
        var phone = $('.js-input-user-phone');
        var code = $('.js-input-user-login-code-part-1').val()
            + $('.js-input-user-login-code-part-2').val()
            + $('.js-input-user-login-code-part-3').val()
            + $('.js-input-user-login-code-part-4').val()
            + $('.js-input-user-login-code-part-5').val();

        AppService.toggleLoader();
        hideError();

        var data = {
            phone: removeBreckets(phone.val()),
            code: code
        };

        $.ajax({
            url: $(this).prop('action'),
            type: $(this).prop('method'),
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function () {
                AppService.toggleLoader();
                AppService.redirectTo("/user/profile");
                LoyaltyService.sendGoogleAnalyticsEventOnCondition(
                    4,
                    $('main.content').attr('data-general-tab') === 'loyalty-intro'
                );
            },
            error: function (data) {
                AppService.toggleLoader();
                showError(data.responseJSON.errors.phone[0], ".js-mod-code-error", '.js-mod-code','.js-mod-login-subtitle');
            }
        });

        return false;
    }

    function repeatSMS() {
        var phone = $('.js-input-user-phone');
        hideError();

        var data = {
            phone: removeBreckets(phone.val()),
        };

        AppService.toggleLoader();
        $.ajax({
            url: '/api/v5/user/send-code',
            type: 'POST',
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: function () {
                AppService.toggleLoader();
                var time = new Date().getTime() + 1 * 60 * 1000;
                backTimer(time);
            },
            error: function (data) {
                AppService.toggleLoader();
                console.log("Error", data.responseJSON);

                showError(data.responseJSON.errors.phone[0], ".js-mod-code-error", '.js-mod-code','.js-mod-login-subtitle');
            }
        });


        return false;
    }

    function backTimer(time) {
        var j = $('.js-send-repeated-sms');
        var i = new Date().getTime();
        j.attr('style', 'pointer-events: none');
        if (i < time) {
            j.text("Следующую смс можно отправить через " + '\n' + new Date(time - i).toLocaleTimeString().substring(2, new Date(time - i).toLocaleTimeString().length));
            setTimeout(backTimer, 100, time);
        } else {
            j.removeAttr('style');
            j.text("Отправить ещё раз");
        }
    }

    function checkCodeValueOnInput() {
        $('.js-next-field-on-input').on('input', function () {
            if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-login-code-part-1')) {
                $('.js-input-user-login-code-part-2').focus();
            } else if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-login-code-part-2')) {
                $('.js-input-user-login-code-part-3').focus();
            } else if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-login-code-part-3')) {
                $('.js-input-user-login-code-part-4').focus();
            } else if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-login-code-part-4')) {
                $('.js-input-user-login-code-part-5').focus();
            } else if ($(this).val().match(/^\d{1}$/) && $(this)[0].classList.contains('js-input-user-login-code-part-5')) {
                $('#js-complete-authorize').trigger("submit");
            } else {
                $(this).val('');
            }
        });
    }

    function checkCodeValueOnKeyUp() {
        $('.js-next-field-on-keyup').keyup(function () {
            if (event.keyCode === 8 && $(this)[0].classList.contains('js-input-user-login-code-part-5')) {
                $('.js-input-user-login-code-part-4').focus();
            } else if (event.keyCode === 8 && $(this)[0].classList.contains('js-input-user-login-code-part-4')) {
                var el = $('.js-input-user-login-code-part-3');
                el.val("");
                el.focus();
            } else if (event.keyCode === 8 && $(this)[0].classList.contains('js-input-user-login-code-part-3')) {
                var el = $('.js-input-user-login-code-part-2');
                el.val("");
                el.focus();
            } else if (event.keyCode === 8 && $(this)[0].classList.contains('js-input-user-login-code-part-2')) {
                var el = $('.js-input-user-login-code-part-1');
                el.val("");
                el.focus();
            }
        });
    }

    function focusOnPhoneInput() {
        $('.js-prefix-clickable').click(function () {
            $('.js-input-login-phone').focus();
        })
    }

    function initializeInputPhoneMask() {
        $(document).ready(function () {
            $('.js-input-login-phone').inputmask("(999) 999-99-99");
        });
    }

    function checkBtnDisabled(selector) {
        if(converStringToPhoneAndAddPrefix($(selector).val()).length < 10){
            $('#btnPhoneSbm').prop( "disabled", true );
        }
        else{
            $('#btnPhoneSbm').prop( "disabled", false );
        }
    }

    function init() {

        $('#js-start-authorization').submit(startAuthorize);
        $('#js-complete-authorize').submit(completeAuthorize);
        $('.js-send-repeated-sms').click(repeatSMS);
        checkBtnDisabled('#loginPhone');
        $('#loginPhone').keyup(function(){    
            checkBtnDisabled(this);
        });
        $('#loginPhone').change(function(){    
            checkBtnDisabled(this);
        });


        $('#modalCompleteAuthorize').on('shown.bs.modal', function (e) {
            LoyaltyService.sendGoogleAnalyticsEventOnCondition(
                3,
                $('main.content').attr('data-general-tab') === 'loyalty-intro'
            );
        });

        initializeInputPhoneMask();
        checkCodeValueOnInput();
        checkCodeValueOnKeyUp();
        focusOnPhoneInput();
    }

    return {
        init: init
    }
})();

$(AuthPhoneService.init);